import React from "react";
import { EditButton, Link } from "react-admin";

export const LinkField = (props) => {
	return <Link to={`${props.resource}/${props.record.id}`}>{props.record[props.source]}</Link>;
};

export const LinkFieldToOther = (props) => {
	return (
		<Link to={`${props.otherResource}/${props.record[props["otherIdProp"]]}`}>
			{props.record[props.source]}
		</Link>
	);
};

export const EditButtonField = (props) => {
	return <EditButton {...props} label={props.record?.[props.source] ?? "\u00A0"} icon={null} />;
};

export const ShowButtonField = ({ formatter = (v) => v, sortable, tabPath, ...props }) => {
	const to = `/${props.resource}/${props.record?.id}/show/${tabPath}`;
	return (
		<Link to={to} onClick={(e) => e.stopPropagation()} target="_blank">
			{formatter(props.record[props.source])}
		</Link>
	);
};
